/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Namespaces } from '../../i18n';
import { INotification } from '../../store/notifications/types';
import { AppServerEvents } from '../../types/common/AppEvents';
import { NotificationItemFrameOptions } from '../../types/notification/NotificationItemFrameOptions';
import { useNotificationRelativeDate } from '../../utils/useNotificationRelativeDate';
import { NotificationItemFrame } from '../NotificationItemFrame/NotificationItemFrame';

type OrganizationInvitationNotificationProps = NotificationItemFrameOptions & {
  notification: INotification<AppServerEvents.RemovedFromOrganization>;
};

export function RemovedFromOrganizationNotification(props: OrganizationInvitationNotificationProps) {
  const { notification, setNotificationAsRead, onRemoveBtnClick, asSnackbar, onRootClick } = props;
  const { createdAt, event, isRead } = notification;
  const { organization, user } = event;
  const { t } = useTranslation([Namespaces.Navigation]);

  const [datetime] = useNotificationRelativeDate(createdAt);
  return (
    <NotificationItemFrame
      datetime={datetime}
      setNotificationAsRead={setNotificationAsRead}
      isRead={asSnackbar ? true : isRead}
      primaryText={t('notifications.templates.user_removed_you_from_organization', {
        user: `${user.firstName} ${user.lastName}`,
      })}
      secondaryText={organization.name}
      id={notification.id}
      onRemoveBtnClick={onRemoveBtnClick}
      asSnackbar={asSnackbar}
      onRootClick={onRootClick}
    />
  );
}
